var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file Component: Table
 * @author wangzixi@baidu.com
 */
/* global window document getComputedStyle*/
import React, { Component, Fragment } from 'react';
import { isEmpty, isArray, isFunction, range, forEach, isEqual } from 'lodash-es';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { contains, getDOMPosition, classPrefix } from '../../common/util';
import Pagination from '../Pagination';
import Tips from '../Tips';
import PopperWrap from '../PopperWrap';

import TableRow from './TableRow';
import TableCell from './TableCell';
import TableHead from './TableHead';
import TableBody from './TableBody';

import './Table.less';

// Table 组件
// data: Array<any>                      显示的数据
// store: Object                         状态管理库的 store
// columnConfigs: Array<any>             列配置
// maxLine: number                       单元格包含最大行数，超出部分隐藏
// fixed: bool                           表头宽度是否固定
// ellipsis: bool                        内容过长是否显示省略号（只能和 fixed 搭配使用）
// emptyDataView: PropTypes.node         数据为空时表格主体内部的显示视图
// pager: Object                         翻页器配置
// classPrefix: string                   类名前缀
// verticalLine: bool                    是否每列添加竖线
// headerColWidthCanChange: bool         是否header的列拖动改变宽度

var Table = function (_Component) {
    _inherits(Table, _Component);

    function Table(props) {
        _classCallCheck(this, Table);

        var _this = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

        _this.bodyClick = function (e) {
            _this.filterIconBodyClick(e);
        };

        _this.filterIconBodyClick = function (e) {
            var label = e.target.getAttribute('data-label');
            if (_this.state.isShowFilterChildren[label] || _this.isFilterChildren(e.target) || _this.isShowFilterChildrenAllFalse()) {
                return;
            }
            _this.setState({ isShowFilterChildren: _this.createFilterObj(_this.props) });
        };

        _this.fixTableWrapScroll = function () {
            var _this$fixTableWrap = _this.fixTableWrap,
                scrollLeft = _this$fixTableWrap.scrollLeft,
                scrollWidth = _this$fixTableWrap.scrollWidth,
                clientWidth = _this$fixTableWrap.clientWidth;

            if (scrollLeft === 0) {
                _this.setState({ fixTableWrapGo: 'left' });
            } else if (scrollLeft === scrollWidth - clientWidth) {
                _this.setState({ fixTableWrapGo: 'right' });
            } else {
                _this.setState({ fixTableWrapGo: 'middle' });
            }
        };

        _this.handleSort = function (refer, sortOption, sort, store) {
            return function () {
                var obj = void 0;
                if (sortOption === _this.state.sortOption) {
                    obj = {
                        sortOption: '',
                        sortedRefer: ''
                    };
                } else {
                    obj = {
                        sortOption: sortOption,
                        sortedRefer: refer
                    };
                }
                sortOption === 'asc' && isFunction(sort.asc) && sort.asc(refer, store);
                sortOption === 'desc' && isFunction(sort.desc) && sort.desc(refer, store);
                isFunction(sort.onChange) && sort.onChange(obj);
                _this.setState(obj);
            };
        };

        _this.rowMouseHover = function (e, index) {
            if (e.type === 'mouseenter') {
                _this.setState({ hoverRowIndex: index });
            } else if (e.type === 'mouseleave') {
                _this.setState({ hoverRowIndex: '' });
            }
        };

        _this.handleTableBodyScroll = function () {
            var isBodyScrolled = Boolean(_this.fixedTableHeader.scrollTop);
            isBodyScrolled !== _this.state.isBodyScrolled && _this.setState({ isBodyScrolled: isBodyScrolled });
        };

        _this.tableHeaderOnMouseMove = function (e) {
            var pageX = e.pageX;
            var _this$tableHeaderTdPo = _this.tableHeaderTdPosition,
                left = _this$tableHeaderTdPo.left,
                width = _this$tableHeaderTdPo.width;

            if (left !== undefined && pageX - left > 0 && width - (pageX - left) <= _this.CURSOR_CHANGE_WIDTH && width - (pageX - left) >= 0) {
                document.body.style.cursor = 'col-resize';
                _this.tableHeaderTdDomCanResize = true;
            } else {
                document.body.style.cursor = '';
                _this.tableHeaderTdDomCanResize = false;
            }
        };

        _this.tableHeaderOnMouseEnter = function (index) {
            _this.tableHeaderTdDomIndex = index;
            _this.tableHeaderTdDom = _this.tableHeaderTds[index];
            _this.tableHeaderTdPosition = getDOMPosition(_this.tableHeaderTds[index]);
        };

        _this.tableHeaderOnMouseLeave = function () {
            document.body.style.cursor = '';
        };

        _this.tableHeaderOnMouseDown = function (index, e) {
            if (_this.tableHeaderTdDomCanResize) {
                _this.tableHeaderTdDomIndexActive = index;
                _this.tableHeaderTdMouseDownPosition = {
                    pageX: e.pageX,
                    right: _this.tableHeaderTdPosition.width - (e.pageX - _this.tableHeaderTdPosition.left)
                };
                // 取消默认选择文字事件
                document.onselectstart = function () {
                    return false;
                };
                document.addEventListener('mousemove', _this.tableHeaderDrag);
                document.addEventListener('mouseup', _this.tableHeaderOnMouseUp);
            }
        };

        _this.tableHeaderOnMouseUp = function () {
            _this.tableEl.style.cursor = '';
            document.removeEventListener('mousemove', _this.tableHeaderDrag);
            document.removeEventListener('mouseup', _this.tableHeaderOnMouseUp);
            // 恢复默认选择文字事件
            document.onselectstart = null;
            _this.updatePopperWraps();
        };

        _this.tableHeaderDrag = function (e) {
            e.preventDefault();
            _this.tableEl.style.cursor = 'col-resize';
            var totalWidth = 0;
            var deltaWidth = e.pageX - _this.tableHeaderTdMouseDownPosition.pageX;
            var newColsWidth = _this.state.colsWidth.map(function (width, index) {
                var newWidth = parseFloat(width);
                if (index === _this.tableHeaderTdDomIndexActive) {
                    newWidth = e.pageX - getDOMPosition(_this.tableHeaderTds[_this.tableHeaderTdDomIndexActive]).left + _this.tableHeaderTdMouseDownPosition.right;
                    deltaWidth = newWidth > _this.MIN_COL_WIDTH ? newWidth - parseFloat(width) : _this.MIN_COL_WIDTH - parseFloat(width);

                    // 被拖动的列会被设置宽度
                    _this.columnConfigsColsWidth[index] = newWidth;
                }
                newWidth = newWidth > _this.MIN_COL_WIDTH ? newWidth : _this.MIN_COL_WIDTH;
                return newWidth + 'px';
            });
            // 没有滚动条且存在未设置宽度的列，拖动增量会分配给没有设置宽度的列
            if (_this.fixTableWrap.scrollWidth <= _this.fixTableWrap.clientWidth && _this.tableHeaderTdDomIndexActive !== _this.props.columnConfigs.length - 1) {
                newColsWidth = newColsWidth.map(function (width, index) {
                    var newWidth = parseFloat(width);
                    if (_this.columnConfigsColsWidth[index] === undefined) {
                        var noWidthConfigNum = _this.columnConfigsColsWidth.filter(function (width) {
                            return width === undefined;
                        }).length;
                        newWidth = newWidth - deltaWidth / noWidthConfigNum;
                    }
                    newWidth = newWidth > _this.MIN_COL_WIDTH ? newWidth : _this.MIN_COL_WIDTH;
                    return newWidth + 'px';
                });
            }
            // 当拖动最后一列或者所有列都设置了宽度，拖动改变表格宽度
            if (_this.tableHeaderTdDomIndexActive === _this.props.columnConfigs.length - 1 || _this.columnConfigsColsWidth.filter(function (width) {
                return width === undefined;
            }).length === 0) {
                totalWidth = newColsWidth.reduce(function (pre, nav) {
                    return pre + parseFloat(nav) || 0;
                }, 0);
                _this.tableEl.style.width = totalWidth + 'px';
                _this.tableElBody.style.width = _this.tableEl.style.width;
            }
            _this.setState({ colsWidth: newColsWidth });

            // 更新tips的popper位置
            _this.props.columnConfigs.forEach(function (config, index) {
                if (config.tips) {
                    _this['tableTips' + index] && _this['tableTips' + index].Popper.update();
                }
            });
        };

        var isShowFilterChildren = _this.createFilterObj(props);
        _this.state = {
            sortOption: '',
            sortedRefer: '',
            isShowFilterChildren: isShowFilterChildren,
            hoverRowIndex: '',
            fixTableWrapGo: 'left',
            isBodyScrolled: false,
            colsWidth: _this.getPropsColsWidth(props)
        };
        _this.filterChildren = {};
        _this.PopperWraps = {};
        _this.filterIcon = {};

        _this.tableHeaderTdPosition = {};
        _this.tableHeaderTdDom = null;
        _this.tableHeaderTdDomIndex = undefined;
        _this.tableHeaderTdDomActive = null;
        _this.tableHeaderTdDomIndexActive = undefined;
        _this.tableHeaderTdDomCanResize = false;
        _this.tableHeaderTdMouseDownPosition = {};
        _this.columnConfigsColsWidth = _this.getPropsColsWidth(props);

        _this.MIN_COL_WIDTH = _this.props.minColWidth; // 最小列宽
        _this.CURSOR_CHANGE_WIDTH = 5; // 鼠标cursor变化的范围
        _this.FIXED_HEADER_HEIGHT = 71; // 固定表头高度
        return _this;
    }

    _createClass(Table, [{
        key: 'getPropsColsWidth',
        value: function getPropsColsWidth(props) {
            return props.columnConfigs.map(function (config) {
                return config.width;
            });
        }
    }, {
        key: 'createFilterObj',
        value: function createFilterObj(props) {
            var obj = {};
            props.columnConfigs.forEach(function (_ref, index) {
                var refer = _ref.refer;

                obj[refer + index] = false;
            });
            return obj;
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(np) {
            if (!isEqual(np.columnConfigs, this.props.columnConfigs)) {
                this.setState({
                    isShowFilterChildren: this.createFilterObj(np),
                    colsWidth: this.getPropsColsWidth(np)
                });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.body.addEventListener('click', this.bodyClick);
            this.fixTableWrap.addEventListener('scroll', this.fixTableWrapScroll);

            if (this.props.verticalLine && this.props.headerColWidthCanChange) {
                // table 添加具体宽度方便控制
                if (this.columnConfigsColsWidth.filter(function (width) {
                    return width === undefined;
                }).length === 0) {
                    this.tableEl.style.width = this.columnConfigsColsWidth.reduce(function (pre, nav) {
                        return pre + parseFloat(nav);
                    }, 0) + 'px';
                    this.tableElBody.style.width = this.tableEl.style.width;
                } else {
                    this.tableEl.style.width = getComputedStyle(this.tableEl)['width'];
                    this.tableElBody.style.width = this.tableEl.style.width;
                }
                this.tableHeaderTds = this.tableEl.querySelectorAll('thead tr td');
                // 给所有col设置宽度
                var newColsWidth = [];
                // IE11 对于NodeList数组不支持forEach方法，普通Array支持
                [].forEach.call(this.tableHeaderTds, function (td, index) {
                    newColsWidth[index] = window.getComputedStyle(td)['width'];
                });

                this.setState({ colsWidth: newColsWidth });
            }

            if (this.props.fixedHeader && this.props.fixedHeight) {
                this.fixedTableHeader.addEventListener('scroll', this.handleTableBodyScroll);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.body.removeEventListener('click', this.bodyClick);
            this.fixTableWrap.removeEventListener('scroll', this.fixTableWrapScroll);

            document.removeEventListener('mousemove', this.tableHeaderDrag);
            document.removeEventListener('mouseup', this.tableHeaderOnMouseUp);

            if (this.props.fixedHeader && this.props.fixedHeight) {
                this.fixedTableHeader.removeEventListener('scroll', this.handleTableBodyScroll);
            }
        }
    }, {
        key: 'isFilterChildren',
        value: function isFilterChildren(target) {
            for (var i in this.filterChildren) {
                if (contains(this.filterChildren[i], target)) {
                    return true;
                }
            }
            return false;
        }
    }, {
        key: 'isShowFilterChildrenAllFalse',
        value: function isShowFilterChildrenAllFalse() {
            var isShowFilterChildren = this.state.isShowFilterChildren;
            for (var i in isShowFilterChildren) {
                if (isShowFilterChildren[i]) {
                    return false;
                }
            }
            return true;
        }
    }, {
        key: 'renderHeader',

        // prettier-ignore
        value: function renderHeader(customColumnConfigs) {
            var _this2 = this;

            var columnConfigs = customColumnConfigs || this.props.columnConfigs;

            return React.createElement(
                TableRow,
                { header: true, style: {
                        transform: 'translate3d(0, 0, 0)', // 开启gpu加速，实现3d阴影效果
                        boxShadow: this.state.isBodyScrolled ? '0 5px 10px -5px rgba(0, 0, 0, 0.2)' : 'none'
                    }
                },
                columnConfigs.map(function (_ref2, index) {
                    var refer = _ref2.refer,
                        title = _ref2.title,
                        align = _ref2.align,
                        sort = _ref2.sort,
                        filter = _ref2.filter,
                        tips = _ref2.tips;

                    var position = 0;

                    var finalTitle = isFunction(title) ? title(_this2.props.store) : title;
                    var mouseEventProps = _this2.props.verticalLine && _this2.props.headerColWidthCanChange ? {
                        onMouseMove: _this2.tableHeaderOnMouseMove,
                        onMouseEnter: _this2.tableHeaderOnMouseEnter.bind(_this2, index),
                        onMouseLeave: _this2.tableHeaderOnMouseLeave,
                        onMouseDown: _this2.tableHeaderOnMouseDown.bind(_this2, index)
                    } : {};
                    return React.createElement(
                        TableCell,
                        _extends({
                            align: align || 'left',
                            key: refer + index,
                            style: {
                                borderBottom: _this2.state.isBodyScrolled ? 0 : '1px solid #E5E5E5'
                            }
                        }, mouseEventProps),
                        React.createElement(
                            'div',
                            { className: 'header-cell-wrapper' },
                            finalTitle,
                            !isEmpty(sort) && ++position && _this2.renderSortIcon(refer, sort, _this2.props.store),
                            !isEmpty(filter) && ++position && _this2.renderFilterIcon({
                                refer: refer,
                                filter: filter,
                                store: _this2.props.store,
                                index: index
                            }),
                            !isEmpty(tips) && ++position && _this2.renderTipsIcon(tips, position, index)
                        )
                    );
                })
            );
        }
    }, {
        key: 'renderSortIcon',
        value: function renderSortIcon(refer, sort, store) {
            var _state = this.state,
                sortOption = _state.sortOption,
                sortedRefer = _state.sortedRefer;

            var sortImgClass = classnames('sort-img-wrapper', { 'sort-img': refer !== sortedRefer }, { 'sort-img-asc': refer === sortedRefer && sortOption === 'asc' }, { 'sort-img-desc': refer === sortedRefer && sortOption === 'desc' });

            return React.createElement(
                'div',
                { className: sortImgClass },
                React.createElement('div', { className: 'sort-asc', onClick: this.handleSort(refer, 'asc', sort, store) }),
                React.createElement('div', { className: 'sort-desc', onClick: this.handleSort(refer, 'desc', sort, store) })
            );
        }
    }, {
        key: 'renderFilterIcon',
        value: function renderFilterIcon(_ref3) {
            var _this3 = this;

            var refer = _ref3.refer,
                filter = _ref3.filter,
                store = _ref3.store,
                index = _ref3.index;

            var label = refer + index;
            if (filter.custom) {
                return React.createElement(
                    'div',
                    { className: 'filter-img-wrapper' },
                    React.createElement(
                        'div',
                        {
                            className: 'filter-img',
                            onClick: function onClick(e) {
                                if (isFunction(filter.onClick)) {
                                    filter.onClick(e);
                                }
                            }
                        },
                        React.createElement(
                            'div',
                            {
                                className: classnames(_defineProperty({
                                    'filter-children': true
                                }, filter.className, !!filter.className)),
                                style: { top: '100%' }
                            },
                            isFunction(filter.children) ? filter.children(refer, store) : filter.children
                        )
                    )
                );
            }
            return React.createElement(
                'div',
                { className: 'filter-img-wrapper' },
                React.createElement(PopperWrap, {
                    ref: function ref(el) {
                        _this3.PopperWraps[label] = el;
                    },
                    containerNode: React.createElement('div', {
                        className: 'filter-img',
                        onClick: function onClick(e) {
                            _this3.setState({
                                isShowFilterChildren: _extends({}, _this3.state.isShowFilterChildren, _defineProperty({}, label, !_this3.state.isShowFilterChildren[label]))
                            }, function () {
                                if (isFunction(filter.onClick)) {
                                    filter.onClick(e, _this3.state.isShowFilterChildren[label]);
                                }
                            });
                        },
                        ref: function ref(el) {
                            _this3.filterIcon[label] = el;
                        },
                        'data-label': refer + index
                    }),
                    popupNode: React.createElement(
                        'div',
                        {
                            className: classnames(_defineProperty({
                                'filter-children': true
                            }, filter.className, !!filter.className)),
                            ref: function ref(el) {
                                _this3.filterChildren[label] = el;
                            }
                        },
                        isFunction(filter.children) ? filter.children(refer, store) : filter.children
                    ),
                    isShowPopup: this.state.isShowFilterChildren[label],
                    onBodyClick: this.bodyClick,
                    popupNodeZIndex: filter.zIndex,
                    preventOverflowEnabled: filter.preventOverflowEnabled || false,
                    popupOnBody: true
                })
            );
        }
    }, {
        key: 'renderTipsIcon',
        value: function renderTipsIcon(tips, position, index) {
            var _this4 = this;

            return React.createElement(
                'div',
                { className: 'tips-wrapper' },
                React.createElement(
                    Tips,
                    _extends({
                        ref: function ref(el) {
                            _this4['tableTips' + index] = el;
                        }
                    }, _extends({}, tips, {
                        placement: 'right',
                        popperContainerIsBody: true
                    })),
                    React.createElement('div', { className: 'tips-img' })
                )
            );
        }
    }, {
        key: 'renderExtraBodyLine',
        value: function renderExtraBodyLine() {
            var _props = this.props,
                store = _props.store,
                columnConfigs = _props.columnConfigs,
                extraBodyLine = _props.extraBodyLine;


            return React.createElement(
                TableRow,
                null,
                React.createElement(
                    TableCell,
                    { colSpan: columnConfigs.length, align: 'center' },
                    extraBodyLine(store)
                )
            );
        }
    }, {
        key: 'renderBody',
        value: function renderBody(customColumnConfigs) {
            var _this5 = this;

            var _props2 = this.props,
                data = _props2.data,
                store = _props2.store,
                maxLine = _props2.maxLine,
                selects = _props2.selects,
                ellipsis = _props2.ellipsis,
                emptyDataView = _props2.emptyDataView;

            var columnConfigs = customColumnConfigs || this.props.columnConfigs;

            if (!data || !data.length) {
                return React.createElement(
                    TableRow,
                    { className: 'empty' },
                    React.createElement(
                        TableCell,
                        { colSpan: selects ? columnConfigs.length + 1 : columnConfigs.length, align: 'center' },
                        customColumnConfigs ? ' ' : emptyDataView || '无数据'
                    )
                );
            }

            var maxHeadHeightStyle = void 0;
            var maxBodyHeightStyle = void 0;
            var plus = 0;
            var rowSpanConfig = {};

            if (maxLine) {
                maxHeadHeightStyle = {
                    maxHeight: maxLine * 24 + 26
                };
                maxBodyHeightStyle = {
                    maxHeight: maxLine * 24,
                    overflow: 'hidden',
                    display: '-webkit-box',
                    WebkitLineClamp: maxLine,
                    WebkitBoxOrient: 'vertical',
                    textOverflow: 'hidden',
                    whiteSpace: 'normal'
                };
            }

            // 将带有 rowSpan 属性的列的标识作为键，rowSpan 属性值作为值
            columnConfigs.forEach(function (config) {
                if (config.hasOwnProperty('rowSpan')) {
                    if (!rowSpanConfig[config.refer]) {
                        rowSpanConfig[config.refer] = config.rowSpan;
                    }
                }
            });

            return data.map(function (rowData, rowIndex) {
                var levels = [];
                var spanlist = {};

                // 遍历 rowSpanConfig，看本条数据是否有需要合并的字段
                forEach(rowSpanConfig, function (spans, refer) {
                    forEach(spans, function (_ref4) {
                        var start = _ref4.start,
                            end = _ref4.end;

                        var step = end - start + 1;
                        // 注意：目前合并的行中，非完全合并的列的初始索引只能和合并行的初始索引相同
                        if (start === rowIndex + plus) {
                            if (!spanlist[refer]) {
                                spanlist[refer] = {
                                    start: start,
                                    end: end
                                };
                            }
                            if (step > 1) {
                                levels.push(step);
                            }
                        }
                    });
                });

                var maxLevel = levels.length ? Math.max.apply(Math, levels) : 1;

                // prettier-ignore
                var body = range(maxLevel).map(function (_, subIndex) {
                    return React.createElement(
                        TableRow,
                        {
                            key: _ + rowIndex,
                            style: maxLine && maxHeadHeightStyle,
                            className: classnames({ 'row-hover': _this5.state.hoverRowIndex === rowIndex }),
                            onMouseEnter: function onMouseEnter(e) {
                                return _this5.rowMouseHover(e, rowIndex);
                            },
                            onMouseLeave: function onMouseLeave(e) {
                                return _this5.rowMouseHover(e, rowIndex);
                            }
                        },
                        columnConfigs.map(function (_ref5, index) {
                            var refer = _ref5.refer,
                                render = _ref5.render,
                                renderLabel = _ref5.renderLabel,
                                align = _ref5.align;

                            var realRowIndex = rowIndex + plus + subIndex;

                            if (!spanlist[refer] || spanlist[refer].start >= realRowIndex || spanlist[refer].end < realRowIndex) {
                                var spanStart = void 0;
                                var spanEnd = void 0;
                                var extraRowNum = void 0;
                                if (spanlist[refer]) {
                                    spanStart = spanlist[refer].start;
                                    spanEnd = spanlist[refer].end;
                                    extraRowNum = spanEnd - spanStart;
                                }
                                var text = rowData[refer];

                                if (spanEnd < realRowIndex) {
                                    text = rowData[refer][subIndex - extraRowNum];
                                }
                                if (isArray(text)) {
                                    text = text[subIndex];
                                }
                                var calcedRowSpan = 1;
                                if (spanlist[refer]) {
                                    if (spanlist[refer].start === realRowIndex) {
                                        calcedRowSpan = spanlist[refer].end - spanlist[refer].start + 1;
                                    }
                                }

                                var cellStyle = classnames({ 'cell-ellipsis': ellipsis }, { 'break-line': !ellipsis }, {
                                    'body-cell-with-border': !isArray(rowData[refer]) && subIndex === 0 || subIndex === maxLevel - 1
                                });

                                return React.createElement(
                                    TableCell,
                                    {
                                        key: refer + index,
                                        className: cellStyle,
                                        title: ellipsis ? render ? renderLabel : rowData[refer] : '',
                                        align: align || 'left',
                                        rowSpan: calcedRowSpan
                                    },
                                    maxLine ? render ? React.createElement(
                                        'div',
                                        {
                                            style: maxLine && maxBodyHeightStyle,
                                            title: renderLabel || text
                                        },
                                        render(text, rowIndex, data[rowIndex], data, store)
                                    ) : React.createElement(
                                        'div',
                                        {
                                            style: maxLine && maxBodyHeightStyle,
                                            title: renderLabel || text
                                        },
                                        text
                                    ) : render ? render(text, rowIndex, data[rowIndex], data, store) : text
                                );
                            }
                        })
                    );
                });

                plus += maxLevel - 1;
                return body;
            });
        }
    }, {
        key: 'renderFixedColumns',
        value: function renderFixedColumns(direction) {
            var _classnames3, _classnames4;

            var _props3 = this.props,
                columnConfigs = _props3.columnConfigs,
                fixed = _props3.fixed,
                className = _props3.className,
                classPrefix = _props3.classPrefix;

            var fixedColumnConfigs = [];

            columnConfigs.forEach(function (config) {
                if (config.fixed === direction) {
                    fixedColumnConfigs.push(config);
                }
            });

            if (!fixedColumnConfigs.length) {
                return;
            }

            var fixedWidth = fixedColumnConfigs.reduce(function (totalWidth, _ref6) {
                var width = _ref6.width;
                return totalWidth + width;
            }, 0);

            var mergedClass = classnames((_classnames3 = {}, _defineProperty(_classnames3, classPrefix + '-table', true), _defineProperty(_classnames3, className, !!className), _defineProperty(_classnames3, classPrefix + '-table-fixed', !!fixed), _defineProperty(_classnames3, classPrefix + '-table-no-border-left', true), _defineProperty(_classnames3, classPrefix + '-table-no-border-right', direction === 'right'), _classnames3));

            var wrapperClass = classnames((_classnames4 = {}, _defineProperty(_classnames4, classPrefix + '-table-overlay', true), _defineProperty(_classnames4, classPrefix + '-table-overlay-right', direction === 'right'), _classnames4));

            return React.createElement(
                'div',
                { style: { borderRadius: 4, width: fixedWidth }, className: wrapperClass },
                React.createElement(
                    'table',
                    { className: mergedClass, style: { width: fixedWidth } },
                    React.createElement(
                        TableHead,
                        null,
                        this.renderHeader(fixedColumnConfigs)
                    ),
                    React.createElement(
                        TableBody,
                        null,
                        this.renderBody(fixedColumnConfigs)
                    )
                )
            );
        }
    }, {
        key: 'updatePopperWraps',
        value: function updatePopperWraps() {
            for (var i in this.PopperWraps) {
                this.PopperWraps[i].update && this.PopperWraps[i].update();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames5,
                _classnames6,
                _this6 = this;

            var _props4 = this.props,
                extraBodyLine = _props4.extraBodyLine,
                pager = _props4.pager,
                fixed = _props4.fixed,
                className = _props4.className,
                style = _props4.style,
                classPrefix = _props4.classPrefix,
                verticalLine = _props4.verticalLine,
                children = _props4.children,
                fixedHeight = _props4.fixedHeight,
                fixedHeader = _props4.fixedHeader;


            var rootClass = classnames((_classnames5 = {}, _defineProperty(_classnames5, classPrefix + '-table-root', true), _defineProperty(_classnames5, classPrefix + '-table-hidden-root', Boolean(fixedHeight)), _classnames5));

            var mergedClass = classnames((_classnames6 = {}, _defineProperty(_classnames6, classPrefix + '-table', true), _defineProperty(_classnames6, className, !!className), _defineProperty(_classnames6, classPrefix + '-table-fixed', !!fixed), _defineProperty(_classnames6, 'td-vertical-line', verticalLine), _classnames6));

            var tBodyWrapCls = classnames(_defineProperty({}, classPrefix + '-tbody-scroll', !!fixedHeader));

            var tBodyWrapStyle = {
                height: fixedHeader && fixedHeight
            };

            return React.createElement(
                Fragment,
                null,
                React.createElement(
                    'div',
                    { className: rootClass },
                    this.state.fixTableWrapGo !== 'left' && this.renderFixedColumns('left'),
                    React.createElement(
                        'div',
                        {
                            style: {
                                overflow: fixedHeight ? 'hidden' : 'auto',
                                height: parseFloat(fixedHeight, 10) + this.FIXED_HEADER_HEIGHT || 'auto'
                            },
                            ref: function ref(el) {
                                _this6.fixTableWrap = el;
                            }
                        },
                        React.createElement(
                            'table',
                            {
                                className: mergedClass,
                                style: style,
                                ref: function ref(el) {
                                    _this6.tableEl = el;
                                }
                            },
                            React.createElement(
                                'colgroup',
                                null,
                                this.state.colsWidth.map(function (width, idx) {
                                    return React.createElement('col', { key: idx, width: width });
                                })
                            ),
                            React.createElement(
                                TableHead,
                                null,
                                this.renderHeader()
                            )
                        ),
                        React.createElement(
                            'div',
                            {
                                className: tBodyWrapCls,
                                style: tBodyWrapStyle,
                                ref: function ref(node) {
                                    _this6.fixedTableHeader = node;
                                }
                            },
                            React.createElement(
                                'table',
                                {
                                    className: mergedClass,
                                    style: style,
                                    ref: function ref(el) {
                                        _this6.tableElBody = el;
                                    }
                                },
                                React.createElement(
                                    'colgroup',
                                    null,
                                    this.state.colsWidth.map(function (width, idx) {
                                        return React.createElement('col', { key: idx, width: width });
                                    })
                                ),
                                children ? children : React.createElement(
                                    TableBody,
                                    null,
                                    isFunction(extraBodyLine) && this.renderExtraBodyLine(),
                                    this.renderBody()
                                )
                            )
                        )
                    ),
                    this.state.fixTableWrapGo !== 'right' && this.renderFixedColumns('right')
                ),
                pager && React.createElement(Pagination, pager)
            );
        }
    }]);

    return Table;
}(Component);

Table.propTypes = {
    data: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
    store: PropTypes.object,
    columnConfigs: PropTypes.array.isRequired,
    maxLine: PropTypes.number,
    selects: PropTypes.bool,
    fixed: PropTypes.bool,
    ellipsis: PropTypes.bool,
    extraBodyLine: PropTypes.func,
    emptyDataView: PropTypes.node,
    pager: PropTypes.object,
    className: PropTypes.string,
    style: PropTypes.object,
    classPrefix: PropTypes.string,
    verticalLine: PropTypes.bool,
    children: PropTypes.node,
    headerColWidthCanChange: PropTypes.bool,
    minColWidth: PropTypes.number,
    fixedHeader: PropTypes.bool,
    fixedHeight: PropTypes.number
};
Table.defaultProps = {
    classPrefix: classPrefix,
    minColWidth: 80
};
export default Table;